import sectionsNames from './sectionsNames';
import sectionsMappings from './sectionsMappings';
import getDynamicSectionFromFieldGroupName from './getDynamicSectionFromFieldGroupName';

import Image from '../Sections/Image';
import Text from '../Sections/Text';
import Quotes from '../Sections/Quotes';
import CallToActionFullwidth from '../Sections/CallToActionFullWidth';
import TopThreeTips from '../Sections/TopThreeTips';
import Video from '../Sections/Video';
import HelpfulGuides from '../Sections/HelpfulGuides';
import CDF from '../Sections/CDF';
import Calculator from '../Sections/Calculator';
import Review from '../Sections/Review';
import CustomerReviews from '../Sections/CustomerReviews';
import QuestionsAnswers from '../Sections/QuestionsAnswers';
import CTAButton from '../Sections/CTAButton';
import Banner from '../Sections/Banner';
import FullWidthReview from '../Sections/FullWidthReview';
import Price from '../Sections/Price';
import Representation from '../Sections/Representation';
import About from '../Sections/About';
import Client from '../Sections/Client';
import Lawyer from '../Sections/Lawyer';
import Tools from '../Sections/Tools';
import Faq from '../Sections/Faq';
import FeesBanner from '../Sections/FeesBanner';
import FeesProcess from '../Sections/FeesProcess';
import FeesCalculate from '../Sections/FeesCalculate';
import Award from '../Sections/Award';
import Tactics from '../Sections/Tactics';
import TacticsBanner from '../Sections/TacticsBanner';
import Autoschedule from '../Sections/AutoSchedule';
import BlogListing from '../Sections/BlogListing';

const DynamicSections = ({ sections, hasSidebar, isHomepage }) => {
  return sections.map((section) => {
    const fieldGroupName = section.fieldGroupName;
    const sectionName = getDynamicSectionFromFieldGroupName(fieldGroupName, sectionsMappings);
    const hasGuides = section?.guides?.length;
    const showHelpFulGuides = section.displayLocation === 'both';
    switch (sectionName) {
      case sectionsNames.BLOG:
        return <BlogListing section={section} />;
      case sectionsNames.VIDEO:
        return <Video videoId={section.videoId} />;
      case sectionsNames.HELPFUL_GUIDES:
        return (
          hasGuides && showHelpFulGuides && <HelpfulGuides guides={section.guides} sidebar="no" />
        );
      case sectionsNames.CALL_TO_ACTION_FULLWIDTH:
        return (
          <CallToActionFullwidth
            ctaText={section.ctaText}
            mainText={section.mainText}
            subText={section.subText}
            ctaUrl={section.ctaUrl}
            ctaImage={section.ctaImage}
            buttonType={section.buttonType}
            newTab={section.newTab}
          />
        );
      case sectionsNames.IMAGE:
        return section?.image?.sourceUrl ? (
          <Image url={section?.image?.sourceUrl} />
        ) : section?.image?.mediaItemUrl ? (
          <Image url={section?.image?.mediaItemUrl} />
        ) : null;
      case sectionsNames.QUOTE:
        return <Quotes unsafeHtml={section.quote} />;
      case sectionsNames.TEXT:
        return <Text unsafeHtml={section.content} />;
      case sectionsNames.TOP_THREE_TIPS:
        return <TopThreeTips tips={section.tips.tip} />;
      case sectionsNames.CDF:
        return (hasSidebar || isHomepage) && <CDF />;
      case sectionsNames.CALCULATOR:
        return <Calculator classNames={'calculator--light'} />;
      case sectionsNames.REVIEWIO:
        return <Review data={section.awardsAndReviews} />;
      case sectionsNames.REVIEWS:
        return <CustomerReviews reviews={section.reviews} />;
      case sectionsNames.QUESTIONS_ANSWERS:
        return <QuestionsAnswers questionsAnswers={section.questionsAnswers} />;
      case sectionsNames.CTA_BUTTON:
        return <CTAButton ctaButton={section} />;
      case sectionsNames.BANNER:
        return <Banner bannerSection={section.bannerSection} />;
      case sectionsNames.FULLWIDTHREVIEW:
        return <FullWidthReview reviewSection={section.reviewSection} />;
      case sectionsNames.PRICE:
        return <Price priceSection={section.priceSection} />;
      case sectionsNames.REPRESENTATION:
        return <Representation data={section} />;
      case sectionsNames.ABOUT:
        return <About aboutSection={section} />;
      case sectionsNames.CLIENT:
        return <Client clientSection={section} />;
      case sectionsNames.LAWYER:
        return <Lawyer lawyerSection={section} />;
      case sectionsNames.TOOLS:
        return <Tools toolSection={section.toolList} />;
      case sectionsNames.FAQ:
        return <Faq />;
      case sectionsNames.FEESBANNER:
        return <FeesBanner bannerData={section} />;
      case sectionsNames.FEESPROCESS:
        return <FeesProcess data={section} />;
      case sectionsNames.FEESCALCULATE:
        return <FeesCalculate data={section} />;
      case sectionsNames.AWARD:
        return <Award data={section} />;
      case sectionsNames.TACTICS:
        return <Tactics data={section} />;
      case sectionsNames.TACTICSBANNER:
          return <TacticsBanner bannerData={section} />;        
      case sectionsNames.AUTOSCHEDULE:
        return <Autoschedule data={section} />;
      default:
        return null;
    }
  });
};

export default DynamicSections;
